<div class="d-flex gap-2">
  <div>
    <label for="file-upload" class="btn-choice">
      <span class="d-block">Attachment:</span>
      <p-fileupload
        [multiple]="true"
        customUpload
        name="file-upload"
        (onClear)="onFileClickRemove()"
        (uploadHandler)="getAttachmentFile($event)"
        class="ms-3 jni-fileupload-hidden"
        #fileEvent
        [auto]="true"
        chooseLabel=""
        [chooseIcon]="''"
        accept="image/png, image/jpeg, .doc, .txt, .xls, .pdf, .docx, .csv, .xlsx .pptx">
        <ng-template
          pTemplate="content"
          let-files
          let-chooseCallback="chooseCallback">
          <div
            class="po-attachment-drag-drop-container"
            (dragover)="onDragOver($event)"
            (drop)="onFileDrop($event)"
            (dragleave)="onDragLeave($event)"
            (dragenter)="onDragEnter($event)">
            <div
              class="po-attachment-drag-drop-area"
              [class.drag-over]="isDragOver">
              <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
              <div class="po-attachment-drag-drop-text">
                <p class="mb-2">Drag & Drop files here</p>
              </div>
            </div>
            <!-- File preview is handled by your custom logic outside this template -->
          </div>
        </ng-template>
      </p-fileupload>
      <!-- <div class="input-field mt-4">
      <input type="text" />
      <button type="button">Select</button>
    </div> -->
    </label>
  </div>

  <div>
    <div class="input-files mx-3">
      <div
        class="d-flex justify-content-between mb-2 gap-2"
        *ngFor="let file of filesObject; let in = index">
        <div>
          <a
            class="has-link"
            style="cursor: pointer"
            (click)="onViewAttachment(file)">
            <span data-toggle="tooltip" title="{{ file.fileName }}">
              {{ file.fileName }}
            </span>
          </a>
          <a>{{ file.fileSizeName }}</a>
        </div>
        <span>
          <a (click)="fileRemove(file)"><i class="pi pi-times"></i></a>
        </span>
      </div>
    </div>
  </div>
</div>
